<template>
  <div id="dashboard-analytics">
    <div class="flex flex-wrap mb-6">
      <vx-card class="sm:w-1/2">
        <swiper :options="swiperOption">
          <swiper-slide v-for="banner in banners" :key="banner.id" v-html="banner.content"></swiper-slide>
          <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
        </swiper>
      </vx-card>

      <div class="sm:w-1/2 plc-2 ptm-2">
        <div class="flex flex-wrap -mb-4">
          <!-- Telas -->
          <div class="w-full sm:w-1/2 mb-4 pr-4">
            <div class="vx-card overflow-hidden">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div>
                  <div class="p-6 pb-0">
                    <router-link to="/desktop/telas">
                      <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                        style="background: rgba(var(--vs-success),0.15);"
                      >
                        <i class="fas fa-images fa-2x"></i>
                      </span>

                      <div>
                        <h2 class="mb-1 font-bold">{{dispositivo.count.screenshot}}</h2>
                        <span>Telas</span>
                      </div>
                    </router-link>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Sites -->
          <div class="w-full sm:w-1/2 mb-4 pr-4">
            <div class="vx-card overflow-hidden">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div>
                  <div class="p-6 pb-0">
                    <router-link to="/desktop/sites">
                      <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                        style="background: rgba(var(--vs-primary),0.15);"
                      >
                        <i class="fas fa-globe fa-2x"></i>
                      </span>
                      <div>
                        <h2 class="mb-1 font-bold">{{dispositivo.count.httptraffic}}</h2>
                        <span>Sites</span>
                      </div>
                    </router-link>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Pesquisas -->
          <div class="w-full sm:w-1/2 mb-4 pr-4">
            <div class="vx-card overflow-hidden">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div>
                  <div class="p-6 pb-0">
                    <router-link to="/desktop/pesquisas">
                      <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
                        style="background: rgba(var(--vs-warning),0.15);"
                      >
                        <i class="fas fa-search fa-2x"></i>
                      </span>
                      <div>
                        <h2 class="mb-1 font-bold">{{dispositivo.count.search}}</h2>
                        <span>Pesquisas</span>
                      </div>
                    </router-link>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Teclas -->
          <div class="w-full sm:w-1/2 mb-4 pr-4">
            <div class="vx-card overflow-hidden">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div>
                  <div class="p-6 pb-0">
                    <router-link to="/desktop/teclas">
                      <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                        style="background: rgba(var(--vs-danger),0.15);"
                      >
                        <i class="fas fa-keyboard fa-2x"></i>
                      </span>
                      <div>
                        <h2 class="mb-1 font-bold">{{dispositivo.count.keylogger}}</h2>
                        <span>Teclas</span>
                      </div>
                    </router-link>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card class="p-4 md:p-0">
          <div>
            <div>
              Informamos que as Teclas Capturadas mais antigas que 7 dias são excluídas automaticamente do painel. Todas as telas ainda podem ser visualizadas através do aplicativo instalado no computador monitorado.
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      banners: [],
      dispositivo: {
        licence: {
          until: null
        }
      },
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  methods: {
    load: function() {
      this.$api
        .get("/api/v1/banners/desktop")
        .then(response => {
          this.banners = response.data.data;
        })
        .catch(() => {});

      // computador
      this.$api
        .get("/api/v1/desktop/device/" + this.$localStorage.get("licencekey"))
        .then(response => {
          this.dispositivo = response.data.data;
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.error || error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    }
  },
  mounted: function() {
    this.load();
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .swiper-slide {
    font-size: 18px;
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: transparent !important;
    justify-content: space-around !important;
  }

  .swiper-slide .title {
    font-size: 41px;
    font-weight: 300;
  }

  .swiper-slide .subtitle {
    font-size: 21px;
  }

  .swiper-slide .text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.3;
  }

  .nova-versao {
    background: linear-gradient(120deg, rgba(41, 204, 160, 0.5));
    color: rgb(255, 255, 255);
  }
  .whatsapp-amigo {
    background: linear-gradient(
        120deg,
        rgba(41, 204, 160, 0.5),
        rgba(10, 88, 74, 0.8)
      ),
      url(../assets/images/elements/fundo-whats.jpg);
    color: rgb(255, 255, 255);
  }

  .youtube-curtir {
    background: linear-gradient(
        120deg,
        rgba(238, 76, 76, 0.5),
        rgba(221, 7, 7, 0.8)
      ),
      url(../assets/images/elements/fundo-youtube.jpg);
    background-size: cover;
    color: rgb(255, 255, 255);
  }

  .plano-vip {
    background: url(../assets/images/elements/191.jpg);
    color: rgb(255, 255, 255);
  }
  .info {
    background: rgb(17, 16, 16);
  }
  .saldos {
    background: linear-gradient(
        120deg,
        rgba(146, 47, 232, 0.5),
        rgb(96, 24, 169)
      ),
      url(../assets/images/elements/bg-saldo.jpg);
    color: rgb(255, 255, 255);
  }
  .question {
    background: linear-gradient(
        120deg,
        rgba(255, 241, 230, 0.5),
        rgb(41, 106, 195)
      ),
      url(../assets/images/elements/question.jpg);
    background-size: cover;
    color: #103161;
  }
  .h {
    height: 160px;
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
    .pr-2 {
      padding-right: 1rem !important;
    }
    .ptm-2 {
      padding-top: 1rem !important;
    }
  }

  @media (min-width: 576px) {
    .prc-2 {
      padding-right: 1rem !important;
    }
    .plc-2 {
      padding-left: 1rem !important;
    }

    .prco-4 {
      padding-right: 1rem !important;
    }
  }
}
</style>
